<template>
  <div class="on-top-header">
    <div class="bg-calendar">
      <div class="pa-4">
        <div class="d-flex justify-space-between align-center">
          <div>
            <div>
              <span class="font-24-header-calendar text-black font-w-600 font-Prompt">
                {{ start | convertMonth('th', 'm') }}
              </span>
              &nbsp;
              <span class="font-20-header-calendar font-w-300 font-Prompt text-gary">
                {{ start | convertMonth('th', 'y') }}
              </span>
            </div>
          </div>
          <div>
            <v-btn :class="[typeOfCalenda == 'month' ? 'btn-type-calendar-red' : 'btn-type-calendar-w']" @click="typeOfCalenda = 'month'">
              <span :class="[typeOfCalenda == 'month' ? 'text-w' : 'text-red']" class="font-16"> เดือน </span>
            </v-btn>
            <v-btn disabled class="btn-type-calendar-none">
              <span class="font-16 text-none">อาทิตย์</span>
            </v-btn>
          </div>
          <div>
            <div class="py-3 d-flex align-center">
              <div class="px-2">
                <v-icon class="btn-card-date-left px-2 py-2" @click="prevMonth">icon-LEFT</v-icon>
                <span @click="goToToday" class="card-date cursor-pointer f-20">วันนี้</span>
                <v-icon class="btn-card-date-right px-2 py-2" @click="nextMonth">icon-RIGHT</v-icon>
              </div>

              <div class="float-right my-4">
                <v-icon>mdi-dots-vertical</v-icon>
              </div>
            </div>
          </div>
        </div>
      </div>

      <v-sheet>
        <v-calendar
          ref="calendar"
          class="bg-calendar height-calendar"
          :type="typeOfCalenda"
          :now="today"
          :value="today"
          color="primary"
          interval-height="120"
          v-model="start"
          locale="th"
        >
          <template v-slot:interval="{ date, time }">
            <div class="schedule-blog" v-if="trackedWeek[date] && trackedWeek[date][time]" style="height: 100%">
              <div class="blog" v-for="(schedule, sIndex) in trackedWeek[date][time]" :key="sIndex" :style="{ height: schedule.lengthTime + '00%' }">
                <div class="head-schedule" :style="{ backgroundColor: colors[schedule.type] }">
                  {{ schedule.type_name }}
                </div>
                <div class="image">
                  <img src="https://x.kinja-static.com/assets/images/logos/placeholders/default.png" alt />
                </div>
                <p>{{ schedule.name }}</p>
              </div>
            </div>
          </template>
          <template v-slot:day-label="{ day, date, time }">
            <div class="row no-gutters">
              <button
                @click="noteOpen(date, time, 'day', 2)"
                type="button"
                :class="{ primary: date == today }"
                class="font-18 color-black-two v-btn v-btn--depressed v-btn--fab v-btn--round theme--light v-size--small transparent align-self-center ml-4"
              >
                <span class="v-btn__content">{{ day }}</span>
              </button>
            </div>
          </template>

          <template v-slot:day="{ date, time }">
            <v-row class="position-relative-box-calendar">
              <template v-if="tracked[date]">
                <v-sheet
                  :style="{ 'border-color': bordercolor(percent.category) }"
                  class="box-calendar"
                  @click="noteOpen(date, time, percent.id, i)"
                  :class="{
                    'box-calendar-circle': percent.type == '5',
                    'box-calendar-radius': percent.type != '5',
                  }"
                  v-for="(percent, i) in getTrackDataLimit(tracked[date])"
                  :key="i"
                  :title="category[percent.category]"
                  :color="colors[+percent.category]"
                  :width="`${percent.counter}%`"
                  height="100%"
                  tile
                >
                  <div class="more-data" v-if="tracked[date].length > 3">
                    <span v-if="i == 2">+{{ tracked[date].length - 3 }}</span>
                  </div>
                </v-sheet>
              </template>
            </v-row>
          </template>
        </v-calendar>
      </v-sheet>
    </div>

    <div class="customer-draggable dragable-no-active" :class="[draggedActive ? 'dragged-hide' : 'dragged-active']">
      <div class="frame card-calendar-list">
        <div class="text-center pt-4" @click="handleDragged()">
          <v-icon v-if="draggedActive">mdi-chevron-double-up</v-icon>
          <v-icon v-else>mdi-chevron-double-down</v-icon>
        </div>

        <v-container class>
          <v-row>
            <v-flex xs12 sm6 md6 lg6 xl6 class="container d-none">
              <v-sheet class>
                <v-switch class="lable-font-18 lable-text-black lable-font-w-500 lable-p" v-model="switch1" label="แสดงรายละเอียด" inset></v-switch>
              </v-sheet>
            </v-flex>
            <v-flex xs12 sm12 md12 lg12 xl12 class="container d-flex justify-content-center">
              <div class="my-md-3 my-xs-2 float-right w-75">
                <v-btn
                  :class="[listToggle == 'list' ? 'btn-type-calendar-red' : 'btn-type-calendar-w']"
                  @click="listToggle = 'list'"
                  style="height: 40px"
                >
                  <span :class="[listToggle == 'list' ? 'font-16 text-w' : 'font-16 text-red']"> รายการ </span>
                </v-btn>
                <v-btn
                  :class="[listToggle == 'map' ? 'btn-type-calendar-red-2' : 'btn-type-calendar-w']"
                  @click="listToggle = 'map'"
                  style="height: 40px"
                >
                  <span :class="[listToggle == 'map' ? 'font-16 text-w' : 'font-16 text-red']"> แผนที่ </span>
                </v-btn>
              </div>
            </v-flex>
            <v-flex xs6 sm1 md1 lg1 xl1 class="container d-none">
              <div class="float-right my-5">
                <v-icon>mdi-dots-vertical</v-icon>
              </div>
            </v-flex>
          </v-row>
        </v-container>
      </div>
      <v-card class="bg-card-gray-calendar d-none">
        <v-container>
          <v-row>
            <v-flex xs3 sm2 md2 lg2 xl2>
              <div>
                <span class="font-18 text-black font-w-500">กรองตาม :</span>
              </div>
            </v-flex>
            <v-flex xs9 sm10 md10 lg10 xl10>
              <v-sheet class style="background-color: #f9f9f9 !important" max-width="700">
                <v-slide-group multiple>
                  <v-slide-item v-slot:default="{ active, toggle }">
                    <v-btn class="mx-2 btn-type-list-calendar" :input-value="active" active-class="btn-type-list-calendar--active" @click="toggle">
                      <v-icon class>icon-Project_type</v-icon>
                      <span class="text-red font-16 font-w-400">เกรดร้าน</span>
                    </v-btn>
                  </v-slide-item>
                  <v-slide-item v-slot:default="{ active, toggle }">
                    <v-btn class="mx-2 btn-type-list-calendar" :input-value="active" active-class="btn-type-list-calendar--active" @click="toggle">
                      <v-icon>icon-COIN</v-icon>
                      <span class="text-red font-16 font-w-400">ยอดตกบวก</span>
                    </v-btn>
                  </v-slide-item>
                  <v-slide-item v-slot:default="{ active, toggle }">
                    <v-btn class="mx-2 btn-type-list-calendar" :input-value="active" active-class="btn-type-list-calendar--active" @click="toggle">
                      <v-icon>icon-SKUWIN</v-icon>
                      <span class="text-red font-16 font-w-400">มือขาย</span>
                    </v-btn>
                  </v-slide-item>
                  <v-slide-item v-slot:default="{ active, toggle }">
                    <v-btn class="mx-2 btn-type-list-calendar" :input-value="active" active-class="btn-type-list-calendar--active" @click="toggle">
                      <v-icon>icon-M59</v-icon>
                      <span class="text-red font-16 font-w-400">ที่ตั้ง</span>
                    </v-btn>
                  </v-slide-item>
                </v-slide-group>
              </v-sheet>
            </v-flex>
          </v-row>
        </v-container>
      </v-card>
      <v-card class="customer-list-height">
        <TheCustomerList v-if="listToggle == 'list'" :toggle-detail="switch1" :listData="listOfCustomer" @search="searchCustomer" />
        <google-map v-if="listToggle == 'map'" :getmarkers="markers"></google-map>
      </v-card>
    </div>
    <!-- 
    <Notecalendars
      :active="noteActive"
      :note="notedata"
      :openfromlist="openFromList"
      @returntolist="returnToList"
      @closenote="toggleNote($event)"
      ref="notecalendar"
    /> -->

    <calendarlistday :active="popupAllCustomer" :customerList="getAllCustomerList" :date="start" @closenote="toggleAllList($event)" />

    <DialogListCalendar :dialog="listActive" :date="dateDialogList" @close-dialog="toggleList($event)" @action-autocomplete="getCustomerList" />
  </div>
</template>
<script>
// import Notecalendars from '@/components/Notecalendar.vue'
import googleMap from '@/components/GoogleCalendar.vue'
import DialogListCalendar from '@/components/v2/calendar/DialogListCalendar.vue'
import calendarlistday from '@/components/CalendarListDay.vue'
import TheCustomerList from '@/components/v2/calendar/TheCustomerListV2.vue'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      noteActive: false,
      listActive: false,
      openFromList: false,
      popupAllCustomer: false,
      getAllCustomerList: [],
      notedata: {
        visit_id: null,
        date: '',
        time: '',
        note: '',
      },
      listFromDate: [],
      dragged: false,
      disabled: false,
      typeOfCalenda: 'month',
      today: new Date().toISOString().split('T')[0],
      start: new Date().toISOString().split('T')[0],
      tracked: {},
      trackedCount: 0,
      trackedWeek: {},
      colors: ['#a4a8ac', '#FF905A', '#9bcb42', '#ffe200', '#dfe4ea', '#ffe200'],
      category: ['รอการเข้าเยี่ยม', 'กำลังเช็คอิน', 'เข้าเยี่ยมเเล้ว', 'เข้าเยี่ยมไม่ตรงแผน', 'เลยแผน', 'เข้าเยี่ยมนอกแผน'],
      switch1: false,
      listToggle: 'list',
      // active: true,
      // toggle: true,
      positions: {
        clientX: undefined,
        clientY: undefined,
        movementX: 0,
        movementY: 0,
      },
      listOfCustomer: [],
      trackCalendar: [],
      markers: [],
      month: new Date().getMonth() + 1,
      year: new Date().getFullYear(),
      windowTop: 0,
      dateDialogList: null,
      search: '',
      draggedActive: false,
    }
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      shop: (state) => state.auth.shop,
    }),
  },

  components: {
    googleMap,
    // Notecalendars,
    calendarlistday,
    DialogListCalendar,
    TheCustomerList,
  },

  directives: {},

  watch: {
    start: function (val) {
      let getCalendarMonth = +val.split('-')[1]
      if (getCalendarMonth != this.month) {
        this.month = getCalendarMonth
        this.getCustomerList()
      }
    },

    search() {
      this.getCustomerList()
    },
  },

  created() {
    this.getCustomerList()
    this.$nextTick(() => {
      const calendarHeight = document.querySelector('.bg-calendar').offsetHeight
      const windowHeight = document.body.offsetHeight
      document.querySelector('.customer-draggable').style.top = 'calc(100vh - 750px)'
      this.$store.dispatch('setTitle', 'ตารางนัดหมาย')
    })
  },

  mounted() {
    document.addEventListener('scroll', this.onScroll)
    this.windowTop = window.scrollY
  },

  methods: {
    bordercolor(status) {
      if (!status) {
        return this.colors[0]
      }
      return status == '3' || status == '5' ? '#d1b001' : this.colors[+status]
    },

    returnToList() {
      this.noteActive = false
      this.listActive = true
      this.openFromList = true
    },

    openNote2(data) {
      this.noteActive = true
      this.listActive = false
      this.notedata.visit_id = data.id
      this.openFromList = true
    },

    goToToday() {
      this.start = this.today
    },

    getAllCustomer(data, date = null) {
      if (data) {
        this.popupAllCustomer = true
        this.getAllCustomerList = data
      }
      this.start = date
    },

    noteOpen(date, time, visitId, index) {
      if (this.tracked[date]) {
        const dataLength = this.tracked[date].length - 3
        if ((dataLength > 0 && index == 2) || visitId == 'day') {
          // case มีข้อมูลเข้าเยี่ยมในปฏิทิน
          // this.dateDialogList = date
          // this.listActive = true
          this.listFromDate = this.tracked[date]
          this.openFromList = true
        } else {
          this.noteActive = true
          this.openFromList = false
        }
        this.notedata.date = date
        this.notedata.time = time
        if (visitId != 'day') {
          this.notedata.visit_id = visitId
        }
      }

      this.dateDialogList = date
      this.listActive = true
    },

    getPositionWindow() {
      this.windowTop = window.scrollY
      document.body.style.position = 'fixed'
      document.body.style.top = `-100px`
    },

    onDragged({ el, deltaX, deltaY, offsetX, offsetY, clientX, clientY, first, last }) {
      const getscrollY = document.body.style.top
      const doc = document.documentElement
      const parent = el.parentElement
      const headerheight = document.querySelector('.bg-navtop-calendar').clientHeight - 50
      let setDeltaY = deltaY
      const t = +window.getComputedStyle(parent)['top'].slice(0, -2) || 0

      if (first) {
        parent.style.transition = ''
        document.body.style.top = -window.scrollY + 'px'
        document.body.style.position = 'fixed'
        document.body.style.width = '100%'
        this.dragged = true
        return
      }

      el.ontouchend = function (event) {
        parent.style.transition = 'all 0.5s ease 0s'
        if (setDeltaY < 0) {
          parent.style.top = headerheight + 'px'
        } else if (setDeltaY > 0) {
          parent.style.top = 'calc(100vh - 750px)'
        }
      }

      el.onmouseup = function (event) {
        parent.style.transition = 'all 0.5s ease 0s'
        if (setDeltaY < 0) {
          parent.style.top = headerheight + 'px'
        } else if (setDeltaY > 0) {
          parent.style.top = 'calc(100vh - 50px)'
        }
      }

      if (last) {
        document.body.style.width = '100%'
        document.body.style.position = ''
        window.scrollTo(0, parseInt(getscrollY || '0') * -1)
        this.dragged = false
        return
      }

      const WY = window.innerHeight
      let windowHeightWithPadding = WY - 50

      if (deltaY > 0 && t < windowHeightWithPadding) {
        parent.style.top = t + deltaY + 'px'
      }

      if (deltaY < 0 && t > headerheight) {
        parent.style.top = t + deltaY + 'px'
      }

      // y = 0
      if (setDeltaY == 0) {
        parent.style.transition = 'all 0.5s ease 0s'
        parent.style.top = 750 + 'px'
      }
    },

    handleDragged() {
      this.draggedActive = !this.draggedActive
    },

    toggleNote(event) {
      this.noteActive = event
    },

    toggleList(event) {
      this.listActive = event
    },

    toggleAllList(event) {
      this.popupAllCustomer = event
    },

    onPosChanged: function (positionDiff, absolutePosition, event) {
      if (absolutePosition) {
        // console.log("left corner", absolutePosition.left);
        // console.log("top corner", absolutePosition.top);
      }
    },

    dragMouseDown: function (event) {
      event.preventDefault()
      // get the mouse cursor position at startup:
      this.positions.clientX = event.clientX
      this.positions.clientY = event.clientY
      document.onmousemove = this.elementDrag
      document.onmouseup = this.closeDragElement
    },

    elementDrag: function (event) {
      event.preventDefault()
      this.positions.movementX = this.positions.clientX - event.clientX
      this.positions.movementY = this.positions.clientY - event.clientY
      this.positions.clientX = event.clientX
      this.positions.clientY = event.clientY
      // set the element's new position:

      this.$refs.draggableContainer.style.top = this.$refs.draggableContainer.offsetTop - this.positions.movementY + 'px'
      this.$refs.draggableContainer.style.left = this.$refs.draggableContainer.offsetLeft - this.positions.movementX + 'px'
    },

    closeDragElement() {
      document.onmouseup = null
      document.onmousemove = null
    },

    searchCustomer(search) {
      this.search = search
    },

    getCustomerList() {
      const paramUser = this.$route.query.userId
      const icon_flag = '/img/icons/pin.png'
      let userId
      if (paramUser) {
        userId = paramUser
      } else {
        userId = 2
      }
      this.$store
        .dispatch('calendar/getListOfCustomer', {
          shop_id: this.shop.id,
          user_id: this.user.id,
          keyword: this.search,
        })
        .then((result) => {
          this.listOfCustomer = this.$store.getters['calendar/getCustomerList'](1)
          this.markers = this.listOfCustomer

            .filter((location) => location.lat_lng)
            .map((location) => {
              if (location.lat_lng) {
                let lat_lng = location.lat_lng.split(',')
                let lat = lat_lng[0] ? +lat_lng[0] : 0
                let lng = lat_lng[1] ? +lat_lng[1] : 0
                return { position: { lat: lat, lng: lng }, icon: icon_flag }
              }
            })
        })

      this.$store
        .dispatch('calendar/getListOfCalendar', {
          month: this.month,
          shop_id: this.shop.id,
          user_id: this.user.id,
          year: this.year,
        })
        .then((result) => {
          this.tracked = this.$store.getters['calendar/getMonthCalendar']

          let countdata = 0
          Object.values(this.tracked).forEach((data) => {
            countdata += +data.length
          })
          this.trackedCount = countdata
        })
    },

    getTrackDataLimit(tracked) {
      const trackLength = tracked.length
      const sliceData = trackLength > 3 ? tracked.slice(0, 3) : tracked
      const newdata = [...sliceData]
      return newdata
    },

    prevMonth() {
      this.$refs.calendar.prev()
      ;(this.tracked = {}), (this.trackedWeek = {})
      this.month = new Date(this.start).getMonth() + 1
      this.year = this.start.slice(0, 4)

      this.getCustomerList()
    },

    nextMonth() {
      this.$refs.calendar.next()
      ;(this.tracked = {}), (this.trackedWeek = {})
      this.month = new Date(this.start).getMonth() + 1
      this.year = this.start.slice(0, 4)
      this.getCustomerList()
    },
  },
}
</script>

<style scoped lang="scss">
.yourButton.v-btn--active::before {
  opacity: 0;
}

.stop-scrolling {
  height: 100vh;
  overflow: hidden;
}

.customer-list-height {
  height: calc(100% - 165px);
}

.box-calendar {
  width: 29px !important;
  height: 29px !important;
  border-width: 1px;
  border-style: solid;
}

.box-calendar .more-data {
  position: absolute;
  color: #fff;
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
}

.v-application .box-calendar-radius {
  border-radius: 4px !important;
}

.v-application .box-calendar-circle {
  border-radius: 50% !important;
}

@media only screen and (max-width: 768px) {
  .box-calendar {
    width: 24px !important;
    height: 24px !important;
  }
}

@media only screen and (max-width: 576px) {
  .customer-list-height {
    height: calc(100% - 140px);
  }
  .box-calendar {
    width: 20px !important;
    height: 20px !important;
    font-size: 12px;
    margin-bottom: 5px;
  }
}

.dragged-active {
  top: calc(100vh - 750px) !important;
}
.dragged-hide {
  top: calc(100vh - 220px) !important;
}
</style>
